// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const editMutation = graphql`
	mutation vocabularyEditMutation($input: VocabularyEditInput!) {
		VocabularyEdit(input: $input) {
			error
			vocabulary {
				id
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: editMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const { error, vocabularyEdge } = response.VocabularyEdit;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, vocabularyEdge);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/components/vocabulary/mutations/vocabulary-edit.js